import { render, staticRenderFns } from "./loginFooter.vue?vue&type=template&id=6c460cb2&scoped=true&"
import script from "./loginFooter.vue?vue&type=script&lang=js&"
export * from "./loginFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c460cb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c460cb2')) {
      api.createRecord('6c460cb2', component.options)
    } else {
      api.reload('6c460cb2', component.options)
    }
    module.hot.accept("./loginFooter.vue?vue&type=template&id=6c460cb2&scoped=true&", function () {
      api.rerender('6c460cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loginPublic/loginFooter.vue"
export default component.exports